import type { User as FirebaseUser } from 'firebase/auth'
import { AuthUser } from '@domain/models/auth-user'

export class AuthUserConverter {
  public static domainModel(fromExternalModel: FirebaseUser | null): AuthUser | null {
    if (!fromExternalModel) {
      return null
    }

    return new AuthUser(
      fromExternalModel.uid,
      fromExternalModel.email,
      fromExternalModel.emailVerified,
      fromExternalModel.metadata.creationTime
        ? new Date(fromExternalModel.metadata.creationTime)
        : null,
      fromExternalModel.metadata.lastSignInTime
        ? new Date(fromExternalModel.metadata.lastSignInTime)
        : null,
    )
  }
}
